module.exports = __webpack_public_path__ + "static/media/spec_labs.2c7cfc59.png";